import React from "react";
import PropTypes from "prop-types";

class Item extends React.Component {
  render() {
    const {
      category: { title: categoryTitle, url: categoryUrl },
    } = this.props;
    const {
      id,
      name,
      description,
      distance,
      slug,
      websiteUrl,
      showOnMap,
      imageUrl,
      selected,
    } = this.props;
    const key = `item-${id}`;

    const distanceListItem = distance && (
      <li className="map-explorer__item__stats__stat">{distance}</li>
    );

    const categoryListItem = (
      <li className="map-explorer__item__stats__stat">
        <a href={categoryUrl}>{categoryTitle}</a>
      </li>
    );

    const websiteAction = websiteUrl && (
      <li className="map-explorer__item__actions__action">
        <a target="blank" href={websiteUrl}>
          Website
        </a>
      </li>
    );

    const renderedImage = imageUrl && (
      <div className="map-explorer__item__image">
        <img alt={name} src={imageUrl} />
      </div>
    );

    const mapAction = showOnMap && (
      <li className="map-explorer__item__actions__action">
        <a onClick={this.props.onMapClick} href="#">
          Map
        </a>
      </li>
    );

    const activeClass = selected ? "map-explorer__item--active" : "";

    return (
      <div id={slug} key={key} className={`${activeClass} map-explorer__item`}>
        {renderedImage}
        <div className="map-explorer__item__content_container">
          <h3 className="map-explorer__item__title">
            <a onClick={this.props.onMapClick} href="#">
              {name}
            </a>
          </h3>
          <ul className="map-explorer__item__stats">
            {categoryListItem}
            {distanceListItem}
          </ul>
          <div
            className="map-explorer__item__content"
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <ul className="map-explorer__item__actions">
            {mapAction}
            {websiteAction}
          </ul>
        </div>
      </div>
    );
  }
}

Item.defaultProps = {
  distance: null,
  websiteUrl: null,
  imageUrl: null,
};

Item.propTypes = {
  category: PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  showOnMap: PropTypes.bool.isRequired,
  description: PropTypes.string.isRequired,
  distance: PropTypes.string,
  websiteUrl: PropTypes.string,
  imageUrl: PropTypes.string,
};

export default Item;
